import { Languages, Moon, Sun, SunMoon } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { applyLocale, type Locale } from "@/i18n/index.ts";
import { applyTheme, readTheme, type Theme } from "@/lib/theme.ts";
import { Button } from "./primitives.tsx";

const nextTheme: Record<Theme, Theme> = { system: "light", light: "dark", dark: "system" };

export function LocaleThemeBar({ compact = false }: { compact?: boolean }) {
  const { t, i18n } = useTranslation();
  const [theme, setTheme] = useState<Theme>(readTheme);
  const Icon = theme === "dark" ? Moon : theme === "light" ? Sun : SunMoon;
  const other: Locale = i18n.language === "ar" ? "en" : "ar";
  return (
    <div className={compact ? "flex flex-col items-center gap-1" : "flex items-center gap-1"}>
      <Button variant="ghost" size="sm" onClick={() => applyLocale(other)} aria-label={t("common.language")} title={other === "ar" ? "العربية" : "English"}>
        <Languages className="size-4" /> {!compact && (other === "ar" ? "العربية" : "English")}
      </Button>
      <Button
        variant="ghost"
        size="sm"
        aria-label={t("common.theme")}
        title={t(`common.theme${theme[0]!.toUpperCase()}${theme.slice(1)}`)}
        onClick={() => {
          const n = nextTheme[theme];
          setTheme(n);
          applyTheme(n);
        }}
      >
        <Icon className="size-4" />
      </Button>
    </div>
  );
}
